import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import SessionRecorder from './SessionRecorder';

const RECORDABLE_PREFIXES = ['/form/', '/application-form', '/payment-details/', '/user-dashboard'];
const POLL_INTERVAL_MS = 500;
const MAX_POLL_ATTEMPTS = 20; // 10 seconds max

const SessionRecorderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const [applicationId, setApplicationId] = useState<string>('');
  const pollRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const shouldRecord = RECORDABLE_PREFIXES.some(p => location.pathname.startsWith(p));

  useEffect(() => {
    if (!shouldRecord) {
      setApplicationId('');
      return;
    }

    // Immediately check
    const id = sessionStorage.getItem('currentApplicationId') || '';
    if (id) {
      setApplicationId(id);
      return;
    }

    // Poll until the form page sets the applicationId in sessionStorage
    let attempts = 0;
    pollRef.current = setInterval(() => {
      attempts++;
      const polledId = sessionStorage.getItem('currentApplicationId') || '';
      if (polledId) {
        setApplicationId(polledId);
        if (pollRef.current) clearInterval(pollRef.current);
      } else if (attempts >= MAX_POLL_ATTEMPTS) {
        if (pollRef.current) clearInterval(pollRef.current);
        console.warn('[SessionRecorderWrapper] Gave up waiting for applicationId');
      }
    }, POLL_INTERVAL_MS);

    return () => {
      if (pollRef.current) {
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
    };
  }, [shouldRecord, location.pathname]);

  return (
    <>
      {shouldRecord && applicationId && <SessionRecorder applicationId={applicationId} />}
      {children}
    </>
  );
};

export default SessionRecorderWrapper;
